import { StyleSheet } from "react-native";

import { sizes, colors } from "asset/constant";
import { mq, sn } from "utils";

export const styles = StyleSheet.create({
  container: {
    width: "100%",
    height: sn(48, 48, 43, 43),
    borderWidth: 1,
    flexDirection: "row",
    alignItems: "center",
    borderRadius: sizes.radius.lg,
    borderColor: colors.border.normal,
    backgroundColor: colors.bg.element,
  },

  textContainer: { flex: 1, paddingHorizontal: mq(5) },

  iconContainer: {
    height: "100%",
    width: mq(25),
    alignItems: "center",
    justifyContent: "center",
    top: mq(2),
  },

  modal: { margin: 0, justifyContent: "flex-end" },

  modalContainer: { flex: 1, backgroundColor: "#00000099" },

  topGap: {
    flex: 1,
    minHeight: mq(20),
    backgroundColor: colors.transparent,
  },

  listContainer: {
    elevation: 10,
    minHeight: mq(50),
    overflow: "hidden",
    borderTopWidth: 3,
    borderRightWidth: 1,
    borderLeftWidth: 1,
    borderColor: colors.border.normal,
    backgroundColor: colors.bg.element,
    borderTopLeftRadius: sizes.radius.md,
    borderTopRightRadius: sizes.radius.md,
  },

  // list: { flexGrow: 1 },

  item: {
    width: "70%",
    height: 45,
    alignItems: "center",
    justifyContent: "center",
    borderBottomWidth: 1,
    borderColor: colors.border.lightest + "66",
    alignSelf: "center",
  },

  listSearchContainer: {
    width: "100%",
    paddingHorizontal: "5%",
    paddingVertical: sizes.space,
  },

  errorContainer: {
    width: "100%",
    bottom: mq(3),
    height: mq(20),
    alignSelf: "flex-end",
    paddingHorizontal: mq(5),
  },

  itemSeparator: {
    height: 1,
    width: "80%",
    alignSelf: "center",
    backgroundColor: colors.border.normal + "33",
  },
});
